import React from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { Checkbox, CheckboxGroup } from 'react-checkbox-group'
import CheckMark from './CheckMark'
import { replaceObjKey } from '../../../helpers/generalHelpers'
import moize from 'moize'
import { isRtl } from '../../../settings'
import FieldWrapper from '../FieldRowWrapper'
import MuiCheckBoxInput from './MuiCheckBoxInput'
import OtherCheckBoxInput from './OtherOptionInput'
import RawHtml from 'stories/components/RawHtml'

if (isRtl) {
  require('./checkbox-input.rtl.css')
} else {
  require('./checkbox-input.ltr.css')
}

const replacer = replaceObjKey({ slug: 'value', title: 'name' })

export default class CheckboxInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectedList: [] }
  }

  convertObserveAbleToJs = (observeAble) =>
    observeAble.toJS ? observeAble.toJS() : observeAble

  onInputChange = ({ selectedList, shouldUpdateParent }) => {
    this.setState(
      // mobx state passes ObserveAbleArrays which are not exactly arrays
      { selectedList: this.convertObserveAbleToJs(selectedList) },
      () => {
        shouldUpdateParent && this.props.onChange(selectedList)
      }
    )
  }

  onOption = (selectedList) => {
    this.onInputChange({
      selectedList,
      shouldUpdateParent: true,
    })
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺👍
    this.props.value &&
      this.onInputChange({
        selectedList: this.props.value,
        shouldUpdateParent: false,
      })
  }

  isChecked = (value) => this.state.selectedList.indexOf(value) !== -1

  generateOptions = moize(
    (options = []) =>
      options.map(({ value, name, image }, index) => (
        <label className="formz-checkbox-label" key={value + index}>
          <Checkbox
            value={value}
            className="formz-checkbox formz-label__checkbox"
            key={value}
          />
          <span className="formz-label__text">
            <span className="formz-label__check">
              <div className="formz-icon">
                <CheckMark selected={this.isChecked(value)} />
              </div>
            </span>
          </span>
          <span className="formz-label-text">
            {image && (
              <img
                src={image}
                alt=""
                style={{
                  width: 100,
                  height: 100,
                  objectFit: 'contain',
                  margin: '0 10px',
                }}
              />
            )}
            {name && <p>{name}</p>}
          </span>
        </label>
      )),
    { isReact: true }
  )

  otherChoiceInput = () => (
    <OtherCheckBoxInput
      name={this.props.name}
      isChecked={this.isChecked}
      uniqueName={this.props.name}
      key={`${this.props.name}-otherCheckBox`}
      valueList={this.state.selectedList}
      onChange={this.onOption}
    />
  )

  render() {
    const {
      label = '',
      name = '',
      options = [],
      required,
      touched,
      description,
      error,
      customized,
      has_other_choice: hasOtherChoice,
    } = this.props

    const classNames = {
      'formz-checkbox-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const renamedOptions = moize((options) => options.map(replacer))

    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <div className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>
            <RawHtml
              className="formz-field-description"
              content={description}
            />
            <CheckboxGroup
              onChange={this.onOption}
              value={this.state.selectedList}
              name={name}
              className="formz-input-field formz-checkbox-wrapper"
            >
              {this.generateOptions(renamedOptions(options))}
              {hasOtherChoice && this.otherChoiceInput()}
            </CheckboxGroup>
          </div>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <MuiCheckBoxInput onChange={this.onInputChange} {...this.props} />
      </FieldWrapper>
    )
  }
}
